import {Component, signal} from '@angular/core';
import {SortOptions} from '../loyalty-layout/loyalty-layout.component';
import {CampaignService} from '../../services/campaign.service';
import {LimitedOffersCarouselComponent} from "./limited-offers-carousel/limited-offers-carousel.component";
import {MatDivider} from '@angular/material/divider';
import {TranslocoDirective} from '@jsverse/transloco';
import {Campaign} from '../../../../../shared-lib/src/lib/services/model';
import {
  CampaignsWithLoyaltyListComponent
} from '../campaigns/campaigns-list-component/campaigns-with-loyalty-list/campaigns-with-loyalty-list.component';

@Component({
  selector: 'app-my-places-screen',
  templateUrl: './my-places-screen.component.html',
  styleUrls: ['./my-places-screen.component.scss'],
  imports: [LimitedOffersCarouselComponent, MatDivider, TranslocoDirective, CampaignsWithLoyaltyListComponent]
})
export class MyPlacesScreenComponent {
  limitedOfferCampaigns = signal<Campaign[]>([]);
  protected readonly SortOptions = SortOptions;

  constructor(campaignService: CampaignService) {
    campaignService.getLimitedOfferCampaigns({sort: SortOptions.HIGHEST_AMOUNT}).subscribe((campaigns) => {
      this.limitedOfferCampaigns.set(campaigns);
    });
  }
}
